import { render, staticRenderFns } from "./BaseSwitchField.vue?vue&type=template&id=5530892c&scoped=true"
import script from "./BaseSwitchField.vue?vue&type=script&lang=js"
export * from "./BaseSwitchField.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitchField.vue?vue&type=style&index=0&id=5530892c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530892c",
  null
  
)

export default component.exports